<template>
  <div id="page-documents">
    <ContentHeader>
      <h6 class="header__meta-title">{{ $wp.metaTitle }}</h6>
      <h1 class="header__title">{{ $wp.header.title }}</h1>
      <p class="header__text">{{ $wp.header.content }}</p>
    </ContentHeader>

    <ContentSection>
      <div class="row -start -wrap">
        <article v-for="doc in documents" :key="doc.id" class="card -article">
          <figure class="card__image" :style="{ backgroundImage: `url(${doc.image})` }" />

          <div class="card__content -document">
            <div>
              <h5 class="card__title">{{ doc.title }}</h5>
              <p>{{ doc.description }}</p>
            </div>

            <a :href="getDocumentLink(doc)" target="_blank" rel="noopener" class="card__link">{{ viewLabel }}</a>
          </div>
        </article>
      </div>
    </ContentSection>
  </div>
</template>

<script>
import { ContentSection, ContentHeader } from '@/components/content'

export default {
  name: 'Documents',
  contentKey: 'documents',
  components: { ContentSection, ContentHeader },
  computed: {
    headerStyle() {
      const { image } = this.$wp.header
      return image ? { backgroundImage: `url(${image})` } : {}
    },
    documents() {
      if (!this.$store.state.collections.documents) return []

      const [last, ...documents] = Object.values(this.$store.state.collections.documents).reverse()
      return [last, ...documents.reverse()]
    },
    viewLabel() {
      return this.$lang.current === 'fr' ? 'Consulter ce document' : 'Read this document'
    }
  },
  methods: {
    getDocumentLink({ documentType = 'doc', documentLink, externalDocumentLink }) {
      return documentType === 'doc' ? documentLink : externalDocumentLink
    }
  }
}
</script>
